import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const BorderLeft = props => (
    <div className={ props.styles.borderWrapper }>
        <div
            className={ classnames({
                [props.styles.borderLeftDispute]: props.dispute,
                [props.styles.borderLeftDiscrepancy]: props.discrepancy,
                [props.styles.noColor]: !props.dispute && !props.discrepancy
            }) }
        />
        <div
            className={ props.styles.borderMargin }
        >
            {props.word}
        </div>
    </div>
);

BorderLeft.propTypes = {
    discrepancy: PropTypes.bool,
    dispute: PropTypes.bool,
    styles: PropTypes.objectOf(PropTypes.string).isRequired,
    word: PropTypes.string
};

BorderLeft.defaultProps = {
    discrepancy: false,
    dispute: false,
    word: ''
};

export default BorderLeft;
